import { render, staticRenderFns } from "./CheckPlugin.vue?vue&type=template&id=19fd1b50&scoped=true"
import script from "./CheckPlugin.vue?vue&type=script&lang=ts"
export * from "./CheckPlugin.vue?vue&type=script&lang=ts"
import style0 from "./CheckPlugin.vue?vue&type=style&index=0&id=19fd1b50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fd1b50",
  null
  
)

export default component.exports